import React from 'react';
import { Slider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const sizeToSpacing: {[key: string]: number} = {
  xs: 1,
  sm: 1.5,
  md: 2,
  lg: 2.5
};

const useStyles = makeStyles(theme => ({
  root: ({ spacing }: { spacing: number }) => ({
    height: theme.spacing(spacing),
    borderRadius: theme.spacing(spacing / 2)
  }),
  rail: ({ spacing }: {spacing: number }) => ({
    height: theme.spacing(spacing),
    borderRadius: theme.spacing(spacing / 2),
    opacity: 1,
    backgroundColor: theme.palette.grey[100]
  }),
  mark: ({ spacing }: {spacing: number }) => ({
    width: 4,
    backgroundColor: 'white',
    height: theme.spacing(spacing),
    borderRadius: 0,
    '&:nth-child(4), &:nth-child(9)': {
      display: 'none'
    }
  }),
  markActive: {
    opacity: 1,
    backgroundColor: 'white'
  },
  track: ({ color, cropTrackBorder, spacing }: {
    color: string,
    spacing: number,
    cropTrackBorder: boolean
  }) => ({
    opacity: 1,
    backgroundColor: color,
    height: theme.spacing(spacing),
    borderRadius: cropTrackBorder
      ? `${theme.spacing(spacing / 2)}px 0 0 ${theme.spacing(spacing / 2)}px`
      : theme.spacing(spacing / 2)
  }),
  thumb: {
    width: 0,
    height: 0,
    marginTop: 0,
    marginLeft: 0,
    display: 'none',
    pointerEvents: 'none'
  }
}));

interface SteppedProgressBarProps {
  value: number,
  color: string,
  max: number,
  size?: string | undefined
}

const FIXED_MAX = 5;
const FIXED_STEP = 1;

export default function SteppedProgressBar ({
  color,
  value = 0,
  size = 'md',
  max = FIXED_MAX
}: SteppedProgressBarProps) {
  const spacing: number = sizeToSpacing[size];
  const trimmedScore: number = Math.min(max, Math.max(0, value));
  const normalizedScore: number = parseInt((100 * trimmedScore / max).toString(), 10);
  const normalizedValue = Math.round((normalizedScore * FIXED_MAX) / 100);
  const cropTrackBorder = normalizedValue < FIXED_MAX;
  const classes = useStyles({ color, spacing, cropTrackBorder });
  return (
    <Slider
      disabled
      classes={{
        root: classes.root,
        rail: classes.rail,
        mark: classes.mark,
        markActive: classes.markActive,
        track: classes.track,
        thumb: classes.thumb
      }}
      defaultValue={normalizedValue}
      marks
      min={0}
      max={FIXED_MAX}
      step={FIXED_STEP}
    />
  );
}
